module.exports = __webpack_public_path__ + "images/cebsb_logo.1790230608476.png";